module.exports = __webpack_public_path__ + "img/satellite2.ac3a84d3.png";